export default __webpack_public_path__ + "static/media/pl_map.8dade97e.png";